module.exports = __webpack_public_path__ + "static/media/sheep.571f6f4e.svg";